/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Range_SelectInputs */

const en_date_range_select = /** @type {(inputs: Date_Range_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date Range Select`)
};

const fr_date_range_select = /** @type {(inputs: Date_Range_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection de période`)
};

const de_date_range_select = /** @type {(inputs: Date_Range_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datumsbereich auswählen`)
};

const it_date_range_select = /** @type {(inputs: Date_Range_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona intervallo di date`)
};

const ru_date_range_select = /** @type {(inputs: Date_Range_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите диапазон дат`)
};

const es_date_range_select = /** @type {(inputs: Date_Range_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar rango de fechas`)
};

const zh_cn2_date_range_select = /** @type {(inputs: Date_Range_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择日期范围`)
};

const ja_date_range_select = /** @type {(inputs: Date_Range_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付範囲の選択`)
};

const hi_date_range_select = /** @type {(inputs: Date_Range_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दिनांक सीमा का चयन करें`)
};

const pt_pt2_date_range_select = /** @type {(inputs: Date_Range_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o intervalo de datas`)
};

/**
* | output |
* | --- |
* | "Date Range Select" |
*
* @param {Date_Range_SelectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const date_range_select = /** @type {((inputs?: Date_Range_SelectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Range_SelectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_date_range_select(inputs)
	if (locale === "de") return de_date_range_select(inputs)
	if (locale === "it") return it_date_range_select(inputs)
	if (locale === "ru") return ru_date_range_select(inputs)
	if (locale === "es") return es_date_range_select(inputs)
	if (locale === "zh-CN") return zh_cn2_date_range_select(inputs)
	if (locale === "ja") return ja_date_range_select(inputs)
	if (locale === "hi") return hi_date_range_select(inputs)
	if (locale === "pt-PT") return pt_pt2_date_range_select(inputs)
	return en_date_range_select(inputs)
});